import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { Send, Trash2, X, Search, Users, Clock, MessageSquarePlus, ChevronDown, ChevronUp } from 'lucide-react';
import EnviarVendedorModal from '../components/EnviarVendedorModal';

const S = {
  heading: { fontSize:22, fontWeight:700, color:'#f6c90e', marginBottom:4 },
  sub: { fontSize:13, color:'#475569', marginBottom:24 },
  searchBox: { display:'flex', alignItems:'center', gap:8, background:'#0e1420', border:'1px solid #1a2035', borderRadius:8, padding:'8px 12px', maxWidth:320, marginBottom:20 },
  searchInput: { background:'none', border:'none', color:'#e2e8f0', fontSize:13, outline:'none', flex:1 },
  table: { width:'100%', borderCollapse:'collapse' },
  th: { padding:'10px 14px', textAlign:'left', fontSize:11, color:'#475569', textTransform:'uppercase', letterSpacing:1, borderBottom:'1px solid #1a2035' },
  td: { padding:'12px 14px', fontSize:13, color:'#cbd5e1', borderBottom:'1px solid #0f1117' },
  actionBtn: (c) => ({ background:`${c}22`, border:`1px solid ${c}44`, borderRadius:6, padding:'5px 9px', cursor:'pointer', color:c, display:'flex', alignItems:'center' }),
  modal: { position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modalCard: { background:'#0e1420', border:'1px solid #1a2035', borderRadius:14, padding:28, width:500, maxWidth:'95vw', maxHeight:'90vh', overflowY:'auto' },
  label: { fontSize:11, color:'#64748b', textTransform:'uppercase', letterSpacing:1, marginBottom:6, display:'block' },
  select: { width:'100%', padding:'10px 12px', borderRadius:8, background:'#0f1117', border:'1px solid #1a2035', color:'#e2e8f0', fontSize:13, outline:'none', marginBottom:16 },
  input: { width:'100%', padding:'10px 12px', borderRadius:8, background:'#0f1117', border:'1px solid #1a2035', color:'#e2e8f0', fontSize:13, outline:'none', marginBottom:16, boxSizing:'border-box' },
  prazoBox: { background:'rgba(246,201,14,0.06)', border:'1px solid rgba(246,201,14,0.2)', borderRadius:10, padding:16, marginBottom:16 },
  btn: (c='#f6c90e') => ({ padding:'10px 18px', borderRadius:8, border:`1px solid ${c}44`, background:`${c}22`, color:c, fontSize:13, fontWeight:700, cursor:'pointer' }),
  infoRow: { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #1a2035', gap:12 },
  tabBar: { display:'flex', gap:4, marginBottom:24, borderBottom:'1px solid #1a2035' },
  tab: (active) => ({
    padding:'9px 20px', fontSize:13, fontWeight:600, cursor:'pointer', border:'none', background:'none',
    color: active ? '#f6c90e' : '#475569',
    borderBottom: active ? '2px solid #f6c90e' : '2px solid transparent',
    marginBottom: -1,
    display:'flex', alignItems:'center', gap:6,
  }),
  badge: (c='#f6c90e') => ({
    background:`${c}22`, border:`1px solid ${c}44`, borderRadius:10,
    padding:'1px 7px', fontSize:11, fontWeight:700, color:c,
  }),
  fuItem: { background:'#080c14', borderRadius:8, padding:'10px 14px', marginBottom:8, border:'1px solid #1a2035' },
  fuDate: { fontSize:11, color:'#a78bfa', fontWeight:700, marginBottom:4 },
  fuNota: { fontSize:13, color:'#cbd5e1', lineHeight:1.5 },
  fuBy: { fontSize:11, color:'#334155', marginTop:4 },
  fuEmpty: { fontSize:13, color:'#334155', textAlign:'center', padding:'16px 0', fontStyle:'italic' },
  fuFormBox: { background:'rgba(167,139,250,0.04)', border:'1px solid rgba(167,139,250,0.2)', borderRadius:10, padding:16, marginTop:12 },
};

const fmtDate = (iso) => {
  if (!iso) return '—';
  try {
    const str = typeof iso === 'string' && !iso.includes('T') ? iso + 'T12:00:00' : iso;
    return new Date(str).toLocaleDateString('pt-BR');
  } catch { return '—'; }
};

const fmtDateTime = (iso) => {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' });
  } catch { return '—'; }
};

export default function PreVendaMeusLeads() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState('pendentes');

  // Modal — enviar para vendedor
  const [editing, setEditing] = useState(null);

  // Modal — follow-up
  const [fuLead, setFuLead] = useState(null);
  const [followups, setFollowups] = useState([]);
  const [fuLoading, setFuLoading] = useState(false);
  const [fuForm, setFuForm] = useState({ data_contato: '', nota: '' });
  const [fuSaving, setFuSaving] = useState(false);
  const [fuError, setFuError] = useState('');
  const [fuShowForm, setFuShowForm] = useState(false);

  const [loadErro, setLoadErro] = useState('');
  const load = () => {
    setLoadErro('');
    api.get('/pre-venda/meus-leads/').then(r => setLeads(r.data)).catch(() => setLoadErro('Erro ao carregar dados. Tente atualizar a página.'));
  };
  useEffect(() => { load(); }, []);

  const pendentes   = leads.filter(l => l.status === 'pre_venda');
  const comVendedor = leads.filter(l => l.status === 'aguardando_vendedor');

  const filtered = (activeTab === 'pendentes' ? pendentes : comVendedor).filter(l =>
    l.cliente_nome?.toLowerCase().includes(search.toLowerCase()) ||
    l.cliente_cidade?.toLowerCase().includes(search.toLowerCase())
  );

  // ── Enviar para vendedor ────────────────────────────────────────────────────
  const openEdit = (lead) => setEditing(lead);

  const handleDelete = async (lead) => {
    if (!window.confirm(`Excluir o lead de ${lead.cliente_nome}? Esta ação não pode ser desfeita.`)) return;
    try {
      await api.delete(`/pre-venda/meus-leads/${lead.id}/`);
      load();
    } catch (e) { alert('Erro ao excluir: ' + e.message); }
  };

  // ── Follow-up ───────────────────────────────────────────────────────────────
  const openFollowup = async (lead) => {
    setFuLead(lead);
    setFuForm({ data_contato: '', nota: '' });
    setFuError('');
    setFuShowForm(false);
    setFuLoading(true);
    try {
      const r = await api.get(`/leads/${lead.id}/followup-pre-venda/`);
      setFollowups(r.data);
    } catch { setFollowups([]); }
    finally { setFuLoading(false); }
  };

  const saveFollowup = async () => {
    if (!fuForm.data_contato) { setFuError('Informe a data do contato.'); return; }
    if (!fuForm.nota.trim())  { setFuError('Informe a nota da conversa.'); return; }
    setFuSaving(true); setFuError('');
    try {
      const r = await api.post(`/leads/${fuLead.id}/followup-pre-venda/`, fuForm);
      setFollowups(prev => [r.data, ...prev]);
      setFuForm({ data_contato: '', nota: '' });
      setFuShowForm(false);
      load();
    } catch (e) {
      setFuError('Erro: ' + (e.response?.data ? JSON.stringify(e.response.data) : e.message));
    } finally { setFuSaving(false); }
  };

  return (
    <div>
      <div style={S.heading}>Meus Leads</div>
      <div style={S.sub}>Leads em Processo de Pré Venda</div>

      {loadErro && (
        <div style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:13, marginBottom:14 }}>{loadErro}</div>
      )}

      {/* Abas */}
      <div style={S.tabBar}>
        <button style={S.tab(activeTab === 'pendentes')} onClick={() => setActiveTab('pendentes')}>
          <Clock size={14} />
          Pendentes
          {pendentes.length > 0 && <span style={S.badge()}>{pendentes.length}</span>}
        </button>
        <button style={S.tab(activeTab === 'com_vendedor')} onClick={() => setActiveTab('com_vendedor')}>
          <Users size={14} />
          Com Vendedor
          {comVendedor.length > 0 && <span style={S.badge('#4ade80')}>{comVendedor.length}</span>}
        </button>
      </div>

      {/* Busca */}
      <div style={S.searchBox}>
        <Search size={14} color="#475569" />
        <input style={S.searchInput} placeholder="Buscar por nome ou cidade..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <div style={{ background:'#0e1420', border:'1px solid #1a2035', borderRadius:12, overflowX:'auto' }}>
        {activeTab === 'pendentes' ? (
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Cliente</th>
                <th style={S.th}>Telefone</th>
                <th style={S.th}>Cidade</th>
                <th style={S.th}>Consumo</th>
                <th style={S.th}>Cadastrado em</th>
                <th style={S.th}>Follow Ups</th>
                <th style={S.th}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(l => (
                <tr key={l.id}
                  onMouseEnter={e => e.currentTarget.style.background='#111827'}
                  onMouseLeave={e => e.currentTarget.style.background=''}>
                  <td style={S.td}>
                    <span
                      style={{ color:'#e2e8f0', fontWeight:600, cursor: l.cliente_id ? 'pointer' : 'default', textDecoration: l.cliente_id ? 'underline' : 'none', textDecorationColor: 'rgba(226,232,240,0.4)', textUnderlineOffset: 2 }}
                      onClick={() => l.cliente_id && navigate(`/jornada/${l.cliente_id}`)}
                    >{l.cliente_nome}</span>
                  </td>
                  <td style={S.td}>{l.cliente_telefone || '—'}</td>
                  <td style={S.td}>{l.cliente_cidade || '—'}</td>
                  <td style={S.td}>{l.cliente_consumo ? `R$ ${Number(l.cliente_consumo).toLocaleString('pt-BR')}` : '—'}</td>
                  <td style={S.td}>{fmtDate(l.criado_em)}</td>
                  <td style={S.td}>
                    {(l.followups_count || 0) > 0
                      ? <span style={S.badge('#a78bfa')}>{l.followups_count}</span>
                      : <span style={{ color:'#334155', fontSize:12 }}>—</span>}
                  </td>
                  <td style={S.td}>
                    <div style={{ display:'flex', gap:8 }}>
                      <button style={S.actionBtn('#a78bfa')} onClick={() => openFollowup(l)} title="Follow Up">
                        <MessageSquarePlus size={13} />
                      </button>
                      <button style={S.actionBtn('#f6c90e')} onClick={() => openEdit(l)} title="Enviar para vendedor">
                        <Send size={13} />
                      </button>
                      <button style={S.actionBtn('#f87171')} onClick={() => handleDelete(l)} title="Excluir">
                        <Trash2 size={13} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={7} style={{ ...S.td, textAlign:'center', color:'#475569', padding:32 }}>
                  {pendentes.length === 0 ? 'Nenhum lead pendente.' : 'Nenhum resultado encontrado.'}
                </td></tr>
              )}
            </tbody>
          </table>
        ) : (
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Cliente</th>
                <th style={S.th}>Vendedor</th>
                <th style={S.th}>Prazo de Contato</th>
                <th style={S.th}>Follow Ups</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(l => (
                <tr key={l.id}
                  onMouseEnter={e => e.currentTarget.style.background='#111827'}
                  onMouseLeave={e => e.currentTarget.style.background=''}>
                  <td style={S.td}>
                    <span
                      style={{ color:'#e2e8f0', fontWeight:600, cursor: l.cliente_id ? 'pointer' : 'default', textDecoration: l.cliente_id ? 'underline' : 'none', textDecorationColor: 'rgba(226,232,240,0.4)', textUnderlineOffset: 2 }}
                      onClick={() => l.cliente_id && navigate(`/jornada/${l.cliente_id}`)}
                    >{l.cliente_nome}</span>
                  </td>
                  <td style={S.td}>
                    {l.vendedor_nome
                      ? <span style={{ color:'#e2e8f0' }}>{l.vendedor_nome}</span>
                      : <span style={{ color:'#475569' }}>—</span>}
                  </td>
                  <td style={S.td}>{fmtDateTime(l.prazo_resposta_vendedor)}</td>
                  <td style={S.td}>
                    {(l.followups_count || 0) > 0
                      ? <span style={S.badge('#a78bfa')}>{l.followups_count}</span>
                      : <span style={{ color:'#334155', fontSize:12 }}>—</span>}
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={4} style={{ ...S.td, textAlign:'center', color:'#475569', padding:32 }}>
                  {comVendedor.length === 0 ? 'Nenhum lead com vendedor ainda.' : 'Nenhum resultado encontrado.'}
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* ── Modal Enviar para Vendedor ─────────────────────────────────────── */}
      {editing && (
        <EnviarVendedorModal
          lead={editing}
          onClose={() => setEditing(null)}
          onSaved={load}
        />
      )}

      {/* ── Modal Follow Up ────────────────────────────────────────────────── */}
      {fuLead && (
        <div style={S.modal} onClick={e => { if (e.target === e.currentTarget) setFuLead(null); }}>
          <div style={S.modalCard}>
            {/* Header */}
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:18 }}>
              <div>
                <div style={{ fontSize:16, fontWeight:700, color:'#a78bfa' }}>Follow Up</div>
                <div style={{ fontSize:12, color:'#475569', marginTop:2 }}>{fuLead.cliente_nome}</div>
              </div>
              <button style={{ background:'none', border:'none', cursor:'pointer', color:'#475569' }} onClick={() => setFuLead(null)}>
                <X size={18} />
              </button>
            </div>

            {/* Histórico */}
            <div style={{ fontSize:11, color:'#64748b', textTransform:'uppercase', letterSpacing:1, marginBottom:8 }}>
              Histórico ({fuLoading ? '…' : followups.length})
            </div>

            {fuLoading ? (
              <div style={{ color:'#334155', fontSize:13, textAlign:'center', padding:16 }}>Carregando...</div>
            ) : followups.length === 0 ? (
              <div style={S.fuEmpty}>Nenhum follow up registrado ainda.</div>
            ) : (
              <div style={{ maxHeight:260, overflowY:'auto', marginBottom:12 }}>
                {followups.map(f => (
                  <div key={f.id} style={S.fuItem}>
                    <div style={S.fuDate}>📅 {fmtDate(f.data_contato)}</div>
                    <div style={S.fuNota}>{f.nota}</div>
                    <div style={S.fuBy}>por {f.criado_por}</div>
                  </div>
                ))}
              </div>
            )}

            {/* Toggle formulário */}
            <button
              style={{
                ...S.btn('#a78bfa'),
                width:'100%', display:'flex', alignItems:'center', justifyContent:'center', gap:6,
              }}
              onClick={() => { setFuShowForm(v => !v); setFuError(''); }}
            >
              {fuShowForm ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
              {fuShowForm ? 'Fechar formulário' : '+ Novo follow up'}
            </button>

            {/* Formulário */}
            {fuShowForm && (
              <div style={S.fuFormBox}>
                <label style={S.label}>Data do contato / visita *</label>
                <input
                  style={S.input}
                  type="date"
                  value={fuForm.data_contato}
                  onChange={e => setFuForm(p => ({ ...p, data_contato: e.target.value }))}
                />

                <label style={S.label}>Como foi a conversa / visita *</label>
                <textarea
                  style={{ ...S.input, height:90, resize:'vertical' }}
                  placeholder="Descreva como foi o contato com o cliente..."
                  value={fuForm.nota}
                  onChange={e => setFuForm(p => ({ ...p, nota: e.target.value }))}
                />

                {fuError && (
                  <div style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:13, marginBottom:12 }}>
                    {fuError}
                  </div>
                )}

                <div style={{ display:'flex', justifyContent:'flex-end', gap:10 }}>
                  <button style={S.btn('#475569')} onClick={() => { setFuShowForm(false); setFuError(''); }}>
                    Cancelar
                  </button>
                  <button style={S.btn('#a78bfa')} onClick={saveFollowup} disabled={fuSaving}>
                    {fuSaving ? 'Salvando...' : 'Salvar Follow Up'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
